import { formatShortDate, formatShortTime } from "src/utils/date";

/** Stacked time + date so the orders table stays narrow without overlapping the Order ID column */
export function OrderRowDate({ createdAt }: { createdAt: number | null | undefined }) {
  if (createdAt == null) {
    return <span className="text-[#9CA3AF] font-normal">–</span>;
  }
  return (
    <div className="flex flex-col gap-0.5 min-w-[6.5rem] py-0.5">
      <span className="text-[12px] leading-tight text-[#6B7280] tabular-nums">
        {formatShortTime(createdAt)}
      </span>
      <span className="text-sm font-medium leading-tight text-[#111827] tabular-nums">
        {formatShortDate(createdAt)}
      </span>
    </div>
  );
}
